export enum BookViewActionTypes {
  SEARCH_BOOK = 'SEARCH_BOOK',
  SEARCH_BOOK_HEATMAP = 'SEARCH_BOOK_HEATMAP',
  CLEAR_BOOK_STATE = 'CLEAR_BOOK_STATE',
  SET_SLIDER_OPTIONS = 'SET_SLIDER_OPTIONS',
  SET_BOOK_SETTINGS = 'SET_BOOK_SETTINGS',
  RESET_BOOK_SETTINGS = 'RESET_BOOK_SETTINGS',
}
